export default "__VITE_ASSET__ely_GsKj__"